import styled from 'styled-components';
import media from '../../../../styles/media.style';
import { WHITE, BLACK, BG_GRAY, BORDER_GRAY } from '../../../../styles/variables.style';

export const Container = styled.div`
  position: relative;
`;

export const Tabs = styled.ul`
  z-index: 100;
  position: fixed;
  display: inline-block;
  top: 55px;
  left: 0;
  width: 100vw;
  max-width: 100%;
  padding: 0;
  margin: 0;
  list-style-type: none;
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  overflow-x: scroll;

  ${media.tabletP`
    display: table;
    top: 105px;
    width: 100%;
    overflow: hidden;
  `};

  > .item:nth-child(4) {
    :after {
      display: none !important;
    }
  }

  &.top {
    > .item:nth-child(1) {
      border-color: ${BORDER_GRAY.COMMON_1} !important;
      background-color: ${BG_GRAY.COMMON_4};
      :after {
        background-color: ${BG_GRAY.COMMON_4};
      }
      .text {
        color: ${WHITE};
      }
    }
  }

  &.care {
    > .item:nth-child(2) {
      border-color: ${BORDER_GRAY.COMMON_1} !important;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: left center;
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA+gAAABkAgMAAABoV/JJAAAADFBMVEUAAACZnqKZnqKZnqIvBE4sAAAAA3RSTlMAgH8BTzA4AAAA/0lEQVR42uXTMQHCQABFsQ8LAyKQgMRKq7TX9TwkHrIr1X6p9km1V6q52edmn5t9bva52edmn5t9bva52edmn5t9bva52edmn5t9bva52edmn5t9bva52edmn5t9bva52edmn5t9bva52edmn5t9bva52edmn5t9bva52edmn5t9bva52edmn5t9bva52edm3+mfZKc7yQ7vKDt8o7jVc6vnVs+tnls9t3pu9dzqudVzq+dWz62eWz23em713Oq51XOr51bPrZ5bPbd6bvXc6rnVc6vnVs+tnls9t3pu9dzqudVzq+dWz62eWz23em713Oq51XOr51bPrZ5bPbd6D3X+v5edFLSlAAAAAElFTkSuQmCC);
      :after {
        background-color: ${BG_GRAY.COMMON_4};
      }
      .text {
        color: ${WHITE};
      }
    }
  }

  &.home-care {
    > .item:nth-child(3) {
      border-color: ${BORDER_GRAY.COMMON_1} !important;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: left center;
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA+gAAABkAgMAAABoV/JJAAAADFBMVEUAAACZnqKZnqKZnqIvBE4sAAAAA3RSTlMAgH8BTzA4AAAA/0lEQVR42uXTMQHCQABFsQ8LAyKQgMRKq7TX9TwkHrIr1X6p9km1V6q52edmn5t9bva52edmn5t9bva52edmn5t9bva52edmn5t9bva52edmn5t9bva52edmn5t9bva52edmn5t9bva52edmn5t9bva52edmn5t9bva52edmn5t9bva52edmn5t9bva52edm3+mfZKc7yQ7vKDt8o7jVc6vnVs+tnls9t3pu9dzqudVzq+dWz62eWz23em713Oq51XOr51bPrZ5bPbd6bvXc6rnVc6vnVs+tnls9t3pu9dzqudVzq+dWz62eWz23em713Oq51XOr51bPrZ5bPbd6D3X+v5edFLSlAAAAAElFTkSuQmCC);
      :after {
        background-color: ${BG_GRAY.COMMON_4};
      }
      .text {
        color: ${WHITE};
      }
    }
  }

  &.confirm {
    > .item:nth-child(4) {
      border-color: ${BORDER_GRAY.COMMON_1} !important;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: left center;
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA+gAAABkAgMAAABoV/JJAAAADFBMVEUAAACZnqKZnqKZnqIvBE4sAAAAA3RSTlMAgH8BTzA4AAAA/0lEQVR42uXTMQHCQABFsQ8LAyKQgMRKq7TX9TwkHrIr1X6p9km1V6q52edmn5t9bva52edmn5t9bva52edmn5t9bva52edmn5t9bva52edmn5t9bva52edmn5t9bva52edmn5t9bva52edmn5t9bva52edmn5t9bva52edmn5t9bva52edmn5t9bva52edm3+mfZKc7yQ7vKDt8o7jVc6vnVs+tnls9t3pu9dzqudVzq+dWz62eWz23em713Oq51XOr51bPrZ5bPbd6bvXc6rnVc6vnVs+tnls9t3pu9dzqudVzq+dWz62eWz23em713Oq51XOr51bPrZ5bPbd6D3X+v5edFLSlAAAAAElFTkSuQmCC);
      .text {
        color: ${WHITE};
      }
    }
  }
`;

export const Tab = styled.li`
  display: inline-block;
  position: relative;
  width: 135px;
  height: 35px;
  line-height: 35px;
  color: ${BLACK};
  vertical-align: middle;
  font-size: 10px;
  box-sizing: content-box;
  border-top: ${BORDER_GRAY.COMMON_1} 1px solid;
  border-bottom: ${BORDER_GRAY.COMMON_1} 1px solid;

  ${media.tabletP`
    display: table-cell;
    width: 25%;
    height: 50px;
    line-height: 50px;
    font-size: 14px;
  `};

  :after {
    pointer-event: none;
    position: absolute;
    right: -12px;
    top: 0;
    display: block;
    width: 35px;
    height: 35px;
    content: '';
    transform: rotate(45deg);
    border-top: solid 1px ${BORDER_GRAY.COMMON_1};
    border-right: solid 1px ${BORDER_GRAY.COMMON_1};

    ${media.tabletP`
      right: -15px;
      top: 0;
      width: 50px;
      height: 50px;
   `};
  }
`;

export const Linker = styled.a`
  text-decoration: none !important;
`;

export const Text = styled.div`
  position: relative;
  z-index: 1;
  margin: 0;
  height: 35px;
  line-height: 35px;
  text-decoration: none !important;

  ${media.tabletP`
    height: 50px;
    line-height: 50px;
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisResultPage/HeaderTab/HeaderTab.style.js